import { HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { EventNotificationsServiceBase } from '../../event-notifications.service-base';
import { EmailStatusesNotificatorBase } from './email-statuses-notificator-base';

export class AccountancyEmailStatusesNotificatorBase extends EmailStatusesNotificatorBase {
    protected url = TaggedUrl.join('accounting/:id/email/status/last', [Tags.Api, Tags.OmitMessage]);
    protected kind = 'AccountingDataExchange';

    public constructor(
        eventNotifications: EventNotificationsServiceBase,
        http: HttpService
    ) {
        super(eventNotifications, http);
    }
}
